/**
 * トースト表示するメッセージを定数管理する
 */
export type ToastAttribute = 'myList' | 'remind' | 'error' | 'other' | 'other-notfound';
export type ToastState = 'add' | 'delete' | 'systemError';

interface ToastMessage {
  attribute: ToastAttribute;
  addText?: string;
  deleteText?: string;
  errorText?: string;
}

export const TOAST_MESSAGES: ToastMessage[] = [
  {
    attribute: 'myList',
    addText: 'お気に入りに登録しました',
    deleteText: 'お気に入りから削除しました',
  },
  {
    attribute: 'remind',
    addText: '通知を有効にしました',
    deleteText: '通知を無効にしました',
  },
  {
    attribute: 'other',
    deleteText: 'データを削除しました。',
  },
  {
    attribute: 'other-notfound',
    deleteText: '削除対象のデータが存在しません。',
  },
  {
    attribute: 'error',
    errorText: '通信に失敗しました。時間を空けて再度お試しください。',
  },
];
